import { useSearchParams } from 'react-router-dom'

export function useQueryParams() {
  const [searchParams] = useSearchParams()
  return {
    from: searchParams.get('from'),
    wb: searchParams.get('wb'),
    idx: searchParams.get('idx'),
  }
}
